// Formateo de moneda (MXN por defecto, segun el esquema) y utilidades de fecha.
import { isPrivate } from './privacy.js';

// Máscara para el modo "ocultar cantidades".
const MASK = '••••••';

const currencyFmt = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',
  minimumFractionDigits: 2,
});

const currencyFmt0 = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export function money(n) {
  if (isPrivate()) return MASK;
  const v = Number(n);
  if (!Number.isFinite(v)) return '—';
  return currencyFmt.format(v);
}

// Sin decimales, para cifras "de un vistazo" (KPIs, patrimonio, presupuestos).
export function money0(n) {
  if (isPrivate()) return MASK;
  const v = Number(n);
  if (!Number.isFinite(v)) return '—';
  return currencyFmt0.format(v);
}

// Días que faltan para terminar el mes actual (incluye hoy).
export function daysLeftInMonth() {
  const d = new Date();
  const last = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
  return last - d.getDate();
}

export function pct(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return '—';
  return `${v.toFixed(0)}%`;
}

// 'YYYY-MM' del mes actual (mes analizado por defecto).
export function currentMonth() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

// 'YYYY-MM-DD' de hoy para inputs date.
export function today() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(
    d.getDate()
  ).padStart(2, '0')}`;
}

export function monthLabel(mes) {
  // mes = 'YYYY-MM'
  const [y, m] = mes.split('-').map(Number);
  const d = new Date(y, m - 1, 1);
  return d.toLocaleDateString('es-MX', { month: 'long', year: 'numeric' });
}

// Etiqueta corta de una fecha 'YYYY-MM-DD' (p. ej. "13 sep"). Si es de otro
// año, incluye el año. Nunca se enmascara: una fecha no es una cantidad.
export function dayLabel(iso) {
  if (!iso) return '';
  const [y, m, d] = String(iso).slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return String(iso);
  const date = new Date(y, m - 1, d);
  const opts =
    y === new Date().getFullYear()
      ? { day: 'numeric', month: 'short' }
      : { day: 'numeric', month: 'short', year: 'numeric' };
  return date.toLocaleDateString('es-MX', opts).replace('.', '');
}
